import { render, staticRenderFns } from "./ZCard.vue?vue&type=template&id=587b11d5&"
var script = {}
import style0 from "./ZCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports